export default "__VITE_ASSET__Dug$_VPU__"